import { useFeature } from '@growthbook/growthbook-react';
import { FEATURES } from '../../constants/featureToggling';

export function useIsCaptureAbsentImageAllowed(): boolean {
  const isSentryEnabled = useFeature(FEATURES.SENTRY).on;
  const isAbsentImageLogEnabled = useFeature(FEATURES.ABSENT_IMAGE_LOG).on;

  return isSentryEnabled && isAbsentImageLogEnabled;
}
